/* ============================================================
   BLACKLIST REVAMP — small UI behaviours (one companion to revamp.css)
   - copy-code button for the offer/coupon badge
   (card image carousel + other behaviours added here as built)
   ============================================================ */
(function () {
  'use strict';

  // Offer/coupon "Copy" button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-code]');
    if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute('data-copy-code') || '';
    var done = function () {
      var prev = btn.textContent;
      btn.textContent = 'Copied';
      setTimeout(function () { btn.textContent = prev; }, 1400);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(done);
    } else {
      var t = document.createElement('textarea');
      t.value = code; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (e2) {}
      document.body.removeChild(t); done();
    }
  });

  // Card image carousel (multi-image): arrows (desktop hover) + native swipe + progress bar
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-bl-carousel]').forEach(function (card) {
      if (card._blcc) return;
      card._blcc = true;
      var track = card.querySelector('[data-bl-cc-track]');
      if (!track) return;
      var bar = card.querySelector('[data-bl-cc-bar]');
      var prev = card.querySelector('[data-bl-cc-prev]');
      var next = card.querySelector('[data-bl-cc-next]');
      function slideW() {
        var s = track.querySelector('.bl-cc__slide');
        return s ? s.getBoundingClientRect().width : track.clientWidth;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var p = max > 0 ? track.scrollLeft / max : 0;
        if (bar) bar.style.transform = 'scaleX(' + Math.max(0.16, p) + ')';
      }
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); track.scrollBy({ left: -slideW(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); track.scrollBy({ left: slideW(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initCarousels(); });
  if (document.readyState !== 'loading') initCarousels();
  window.BlacklistInitCarousels = initCarousels;
})();
